import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { uiKitsKeys } from './uiKitsKeys';
import { IUIKitsQueryParams } from './useQueryUIKits';
import { IUpsertUIKitParams } from './useCreateUIKitMutation';

interface IUpdateUIKitProps {
  id?: number;
  payload: IUpsertUIKitParams;
}

const updateUIKit = async (params: IUpdateUIKitProps) => {
  const { id, payload } = params;
  return await EXPRESS_API.put(`/superadmin/uikit/${id}`, payload);
};

export const useUpdateUIKitMutation = (
  handleGoBack: () => void,
  params?: IUIKitsQueryParams
) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(updateUIKit, {
    onSuccess: () => {
      successToast({ title: 'UI Kit has been successfully updated!' });
      if (params) {
        queryClient.refetchQueries(uiKitsKeys.list(params));
      }
      handleGoBack();
    },
    onError: error =>
      showError(error, 'An error occured while updating the UI Kit!'),
  });
};
